import type { ReactNode } from "react";
import { styled } from "~/common/mui";
import { C_MEDIAS_PLUS, C_PRIMARY_HOVER } from "~/common/components/icon/Colors";

export const ProductTabularViewActionCellLayout = ({ children }: { children: ReactNode }) => (
  <ActionCellRoot>
    <ActionCellInner>{children}</ActionCellInner>
  </ActionCellRoot>
);

export const ActionTextLinkCell = ({
  onClick,
  disabled,
  className,
  cad,
  invisible,
  missingCad,
  ...rest
}: {
  children?: ReactNode;
  href?: string;
  target?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  cad?: boolean;
  invisible?: boolean;
  missingCad?: boolean;
}) => (
  <ActionTextLink
    {...rest}
    $cad={cad}
    $invisible={disabled || invisible}
    $missingCad={missingCad}
    aria-disabled={disabled ? true : undefined}
    className={className}
    onClick={disabled ? undefined : onClick}
    tabIndex={disabled ? -1 : undefined}
  />
);

const ActionCellRoot = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

const ActionCellInner = styled("div")(({ theme }) => ({
  display: "flex",
  marginLeft: "auto",
  background: theme.palette.primary.main,
  "& > *": {
    height: theme.spacing(4.75),
    width: theme.spacing(4.75),
  },
}));

const ActionTextLink = styled("a", {
  shouldForwardProp: (prop) => prop !== "$cad" && prop !== "$invisible" && prop !== "$missingCad",
})<{
  $cad?: boolean;
  $invisible?: boolean;
  $missingCad?: boolean;
}>(({ theme, $cad, $invisible, $missingCad }) => ({
  color: theme.palette.primary.contrastText,
  padding: $cad ? 0 : `0 ${theme.spacing(1.25)}`,
  background: theme.palette.primary.main,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  visibility: $invisible ? "hidden" : undefined,
  ...($missingCad && {
    background: C_MEDIAS_PLUS,
    width: "100%",
    height: "100%",
  }),
  "&:hover": {
    background: C_PRIMARY_HOVER,
    color: theme.palette.primary.contrastText,
  },
  "&:visited, &:active, &:focus": {
    color: theme.palette.primary.contrastText,
  },
  ...($cad && {
    "& > img": {
      width: theme.spacing(3.125),
    },
  }),
}));
